import React from "react";
import { Col, Row } from "reactstrap";
import { H6 } from "../../../../../AbstractElements";
import { ProfileDetailProp } from '../../../../../Types/CommonComponent.type';


interface ProfileMailProps {
    email: string;
    bod: string;
}

const ProfileMail: React.FC<ProfileMailProps> = ({ email, bod }) => {
    return (
         <>
     
        <Col sm={6} xl={4} className="order-sm-1 order-xl-0">
            <Row className="g-3">
                <Col md={6}>
                    <div className="ttl-info text-start">
                        <H6>
                            <i className="fa-solid fa-envelope" aria-hidden="true" /> Email
                        </H6>
                        <span>{email}</span>
                    </div>
                </Col>
                <Col md={6}>
                    {/* <div className="ttl-info text-start">
                        <H6>
                            <i className="fa-regular fa-calendar-days" aria-hidden="true" /> Date of Birth
                        </H6>
                        <span>{bod}</span>
                    </div> */}
                </Col>
            </Row>
        </Col>
        </>
    );
};

export default ProfileMail;
